import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PrimaryButton = styled(MuiButton)(({ theme }) => ({
  borderRadius: (Number(theme.shape.borderRadius) * 15) / 2,
  boxShadow: theme.shadows[11],
  fontSize: 20,
  padding: '14px 16px',
  lineHeight: 1,
  fontWeight: 400,
  textTransform: 'inherit',
  fontFamily: `${theme.typography.secondaryFontFamily} !important`,
  minWidth: 280,
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    background: theme.palette.primary.main,
  },
  '&.Mui-disabled': {
    borderColor: theme.palette.disabled.main,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.icons.main,
  },
}));
